package com.eladfinish.bible.contest.screens.chapterComplete.usecases

import com.eladfinish.bible.contest.common.json
import com.eladfinish.bible.contest.screens.chapterComplete.model.RemoteCompletionJsonKeys.BLANKS
import com.eladfinish.bible.contest.screens.chapterComplete.model.RemoteCompletionJsonKeys.BOOK_INDEX
import com.eladfinish.bible.contest.screens.chapterComplete.model.RemoteCompletionJsonKeys.CHAPTER_INDEX
import com.eladfinish.bible.contest.screens.chapterComplete.model.SavedCompletionData
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

class ParseSavedCompletionDataUseCase {

    operator fun invoke(
        raw: String?,
    ): SavedCompletionData? {
        val input = raw?.trim().orEmpty()
        if (input.isBlank()) return null

        // First try the current/complete model.
        val parsed = runCatching {
            json.decodeFromString(
                deserializer = SavedCompletionData.serializer(),
                string = input,
            )
        }.getOrNull()

        if (parsed != null) return parsed

        // Fallback for legacy payloads missing pickedBookEng/pickedBookHeb.
        val legacy = runCatching {
            json.decodeFromString(
                deserializer = SavedCompletionLegacyPayload.serializer(),
                string = input,
            )
        }.getOrNull() ?: return null

        return SavedCompletionData(
            pickedBookEng = "",
            pickedBookHeb = "",
            bookIndex = legacy.bookIndex,
            chapter = legacy.chapter,
            blanks = legacy.blanks,
        )
    }

    @Serializable
    private data class SavedCompletionLegacyPayload(
        @SerialName(BOOK_INDEX) val bookIndex: Int,
        @SerialName(CHAPTER_INDEX) val chapter: Int,
        @SerialName(BLANKS) val blanks: List<List<Int>>,
    )
}
